import React from 'react';

import ProteinConstants, {
  PRECISION_ISOELECTRIC_POINT,
  getMolecularWeightPrecision,
} from 'molbio/proteins/util/ProteinConstants';
import * as ProteinProperties from 'molbio/proteins/util/ProteinProperties';
import * as sequtil from 'molbio/SeqUtil';

export interface ProteinStatusBarProps {
  aminoAcids: string;
  selection: {
    start: number;
    end?: number;
  };
}

class ProteinStatusBar extends React.Component<ProteinStatusBarProps> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  _renderProteinSelectionStatus = () => {
    const aminoAcids = sequtil.residueSlice(
      this.props.aminoAcids,
      this.props.selection.start,
      this.props.selection.end,
      false
    );
    const [start, end] = sequtil.modelRangeToDisplay(
      this.props.selection.start,
      this.props.selection.end,
      this.props.aminoAcids.length,
      ProteinConstants.DEFAULT_START_INDEX
    );
    if (this.props.selection.end != null) {
      return [
        <div className="statusbar-group" key="start">
          <div className="statusbar-label">Start</div>
          <div className="statusbar-field selectable">{start}</div>
        </div>,
        <div className="statusbar-group" key="end">
          <div className="statusbar-label">End</div>
          <div className="statusbar-field selectable">{end}</div>
        </div>,
        <div className="statusbar-group" key="length">
          <div className="statusbar-label">Length</div>
          <div className="statusbar-field selectable">{aminoAcids.length}</div>
        </div>,
        <div className="statusbar-group" key="mw">
          <div className="statusbar-label">MW</div>
          <div className="statusbar-field selectable">
            {ProteinProperties.getMolecularWeight(aminoAcids).toFixed(getMolecularWeightPrecision())}
          </div>
        </div>,
        <div className="statusbar-group" key="pI">
          <div className="statusbar-label">pI</div>
          <div className="statusbar-field selectable">
            {ProteinProperties.getIsoelectricPoint(aminoAcids).toFixed(PRECISION_ISOELECTRIC_POINT)}
          </div>
        </div>,
      ];
    }
    return (
      <div className="statusbar-group">
        <div className="statusbar-label">Insert</div>
        <div className="statusbar-field selectable">{start}</div>
      </div>
    );
  };

  render(): JSX.Element {
    return (
      <div>
        <div className="statusbar-section">
          <div className="statusbar-group">
            <div className="statusbar-label">Amino Acids</div>
            <div className="statusbar-field selectable">{this.props.aminoAcids.length}</div>
          </div>
        </div>
        <div className="statusbar-section">{this._renderProteinSelectionStatus()}</div>
      </div>
    );
  }
}

export default ProteinStatusBar;
